import { connect } from 'react-redux'
import MaintenanceOrderViewComponent from '../components/MaintenanceOrderViewComponent.jsx';
import {
	findAllCustomerIds,
	forwardToFindMOrderDetails,
} from '../actions';

function showNote(roles) {
	// return roles.includes("ROLE_FIREFIGHTER_ORDER_CRUD");
	/* TODO chichun :'not impl' */
	return 'Not Implement';
}

const mapStateToProps = (state) => ({
	orderDetail: state.getIn(['maintenanceOrderReducer', 'orderDetail']),
	order: state.getIn(['maintenanceOrderReducer', 'order']),

	orderValidation: state.getIn(['maintenanceOrderReducer', 'orderValidation']),
	showNote: showNote(state.getIn(['authReducer', 'roles']).toJS())
})

const mapDispatchToProps = (dispatch) => ({
	findAllCustomerIds: () => {
		dispatch(findAllCustomerIds());
	},

	findMaintenanceOrderDetails: (orderId) => {
		dispatch(forwardToFindMOrderDetails(orderId));
	},
})

const MaintenanceOrderViewContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(MaintenanceOrderViewComponent)

export default MaintenanceOrderViewContainer;


// WEBPACK FOOTER //
// ./src/containers/MaintenanceOrderViewContainer.jsx